import { render, staticRenderFns } from "./paMonitor.vue?vue&type=template&id=5cb0dbde&lang=pug"
import script from "./paMonitor.vue?vue&type=script&lang=js"
export * from "./paMonitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports